.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

/* Body, sentence case, above the box. Fluent labels are words, not legends. */
.label {
  font-size: var(--text-sm);
  font-weight: 400;
  color: var(--ink);
}

/* Fluent's text box: a control fill, a subtle stroke on three sides and a
   firm one on the bottom, which is where the caret lives. On focus the bottom
   stroke thickens to 2px of accent and the rest stays.

   The stroke lives on the shell, not the input, so a prefix or suffix sits
   inside the same box as the text instead of beside it. */
.shell {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  height: var(--control-h-md);
  background: var(--control-fill);
  border: var(--border-hairline) solid var(--line-control);
  border-radius: var(--radius-md);
  box-shadow: var(--well-edge);
  padding-inline: var(--space-3);
  transition:
    border-color var(--duration-fast) var(--ease-out),
    background-color var(--duration-fast) var(--ease-out),
    box-shadow var(--duration-fast) var(--ease-out);
}

.shell:hover {
  background: var(--control-fill-hover);
}

.shell:focus-within {
  background: var(--surface-raised);
  box-shadow: inset 0 -2px 0 var(--accent);
}

.shell[data-invalid] {
  border-color: var(--danger);
  box-shadow: inset 0 -1px 0 var(--danger);
}

.shell[data-invalid]:focus-within {
  box-shadow: inset 0 -2px 0 var(--danger);
}

/* The shell sets the height and centres this; the input contributes its line
   box and nothing else. */
.control {
  flex: 1;
  min-width: 0;
  padding-block: 0;
  font-size: var(--text-sm);
  color: var(--ink);
}

.control:focus {
  outline: none;
  box-shadow: none;
}

.control::placeholder {
  color: var(--ink-faint);
}

.control:disabled {
  cursor: not-allowed;
  color: var(--ink-faint);
}

.shell[data-multiline] {
  height: auto;
  align-items: stretch;
}

/* A textarea holding a compose document or a list of terms is read as code. */
textarea.control {
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  line-height: var(--leading-normal);
  padding-block: var(--space-2);
}

.affix {
  flex: none;
  font-size: var(--text-xs);
  color: var(--ink-faint);
  white-space: nowrap;
}

.hint,
.error {
  font-size: var(--text-xs);
  line-height: var(--leading-snug);
}

.hint {
  color: var(--ink-muted);
}

.error {
  color: var(--danger);
}
